// Mirrors backend/Src/Core/ProPool.Domain/Enums/ResourceType.cs - order matters, values are
// serialized as plain integers (no JsonStringEnumConverter configured).
export enum ResourceType {
	Tournament,
	Match,
	League,
	Team,
	Place
}
